import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTaobaoComponent } from './simple-icons-taobao.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTaobaoComponent ],
    exports:      [ SimpleIconsTaobaoComponent ],
    bootstrap:    []
})
export class SimpleIconsTaobaoModule {}
